import { render, staticRenderFns } from "./LibraryViewReadOnly.vue?vue&type=template&id=a90aa36a&scoped=true&"
import script from "./LibraryViewReadOnly.vue?vue&type=script&lang=js&"
export * from "./LibraryViewReadOnly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a90aa36a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
installComponents(component, {VCard,VCardText})
